/**
 * Las pantallas de Clerk, en español DE TÚ.
 *
 * Clerk trae su español de usted —«Regístrese», «Ingrese su dirección»—, que en España suena a
 * banco o a formulario de Hacienda. Regla de la casa (Rais, 11-sep-2026): todo de tú, directo.
 *
 * Se transforma el diccionario entero en vez de reescribir 838 cadenas a mano: al actualizar Clerk
 * entran sus textos nuevos ya tuteados. La prueba `qa/tuteo.test.mjs` falla si queda alguna forma
 * de usted, así que una cadena que se escape se ve antes de enseñarla.
 */
import { esES } from "@clerk/localizations";

const CAMBIOS: [RegExp, string][] = [
  [/\bIngrese\b/g, "Introduce"], [/\bingrese\b/g, "introduce"],
  [/\bIntroduzca\b/g, "Introduce"], [/\bintroduzca\b/g, "introduce"],
  [/\bRegístrese\b/g, "Regístrate"], [/\bregístrese\b/g, "regístrate"],
  [/\bInicie sesión\b/g, "Inicia sesión"], [/\binicie sesión\b/g, "inicia sesión"],
  [/\bConfirme\b/g, "Confirma"], [/\bconfirme\b/g, "confirma"],
  [/\bElija\b/g, "Elige"], [/\belija\b/g, "elige"],
  [/\bSeleccione\b/g, "Selecciona"], [/\bseleccione\b/g, "selecciona"],
  [/\bContinúe\b/g, "Continúa"], [/\bcontinúe\b/g, "continúa"],
  [/\bVuelva\b/g, "Vuelve"], [/\bvuelva\b/g, "vuelve"],
  [/\bHaga clic\b/g, "Haz clic"], [/\bhaga clic\b/g, "haz clic"],
  [/\bGuarde\b/g, "Guarda"], [/\bVerifique\b/g, "Verifica"], [/\bverifique\b/g, "verifica"],
  [/\bCompruebe\b/g, "Comprueba"], [/\bcompruebe\b/g, "comprueba"],
  [/\bIntente\b/g, "Intenta"], [/\bintente\b/g, "intenta"],
  [/\bUtilice\b/g, "Usa"], [/\butilice\b/g, "usa"], [/\bUse\b/g, "Usa"],
  [/\bAsegúrese\b/g, "Asegúrate"], [/\basegúrese\b/g, "asegúrate"],
  [/\bContacte\b/g, "Contacta"], [/\bPóngase\b/g, "Ponte"], [/\bpóngase\b/g, "ponte"],
  [/\bConfigure\b/g, "Configura"], [/\bElimine\b/g, "Elimina"], [/\bActualice\b/g, "Actualiza"],
  [/\bRestablezca\b/g, "Restablece"], [/\bEstablezca\b/g, "Establece"],
  [/\bEscriba\b/g, "Escribe"], [/\bAgregue\b/g, "Añade"], [/\bAñada\b/g, "Añade"],
  [/\bRevise\b/g, "Revisa"], [/\bCree\b/g, "Crea"], [/\bEspere\b/g, "Espera"],
  [/\bPulse\b/g, "Pulsa"], [/\bAcepte\b/g, "Acepta"], [/\bGestione\b/g, "Gestiona"],
  [/\bescanee\b/g, "escanea"], [/\bingrese\b/g, "introduce"],
  [/\balmacénelos\b/g, "guárdalos"], [/\bpierde\b/g, "pierdes"],
  [/\bDesea\b/g, "Quieres"], [/\bdesea\b/g, "quieres"],
  [/\busted\b/g, "tú"], [/\bUsted\b/g, "Tú"],
  // El posesivo de cortesía, al final: «su cuenta» → «tu cuenta».
  [/\bSu\b/g, "Tu"], [/\bsu\b/g, "tu"], [/\bSus\b/g, "Tus"], [/\bsus\b/g, "tus"],
];

// «En su lugar» es «en vez de eso», no «en tu lugar»: se aparta antes de cambiar posesivos.
const APARTE = " ENSULUGAR ";

function tutear<T>(v: T): T {
  if (typeof v === "string") {
    let s: string = v.replace(/en su lugar/g, APARTE);
    for (const [re, r] of CAMBIOS) s = s.replace(re, r);
    return s.split(APARTE).join("en su lugar") as T;
  }
  if (Array.isArray(v)) return v.map(tutear) as T;
  if (v && typeof v === "object") return Object.fromEntries(Object.entries(v).map(([k, x]) => [k, tutear(x)])) as T;
  return v;
}

export const esTu: typeof esES = tutear(esES);
